import {
  FETCH_CSR_AGENT_REPORT,
  FETCH_CSR_AGENT_REPORT_START,
  FETCH_CSR_AGENT_REPORT_END,
  FETCH_CSR_AGENT_REPORT_ERROR,
  REMOVE_CSR_AGENT_REPORT,
} from '../actions/types';

const initialState = {
  isLoading: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_CSR_AGENT_REPORT:
      return { ...state, report: action.payload };
    case FETCH_CSR_AGENT_REPORT_START:
      return { ...state, isLoading: true };
    case FETCH_CSR_AGENT_REPORT_END:
      return { ...state, isLoading: false };
    case FETCH_CSR_AGENT_REPORT_ERROR:
      return { ...initialState, error: action.payload };
    case REMOVE_CSR_AGENT_REPORT:
      return { ...initialState };
    default:
      return state;
  }
}
